import React from 'react';

const Daas = (props) => (
    <svg
        width="22px"
        height="20px"
        viewBox="0 0 22 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/Del b@1.5x</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-387.000000, -1642.000000)" fill="#000000">
                <g id="Icon/Del-b" transform="translate(387.000000, 1642.000000)">
                    <path
                        d="M18.056333,0.25 C18.3299648,0.25 18.5818803,0.399022096 18.7136474,0.638838253 L21.4073144,5.54131217 C21.4681196,5.65197767 21.5,5.77620386 21.5,5.90247392 L21.5,19 C21.5,19.4142136 21.1642136,19.75 20.75,19.75 L1.25,19.75 C0.835786438,19.75 0.5,19.4142136 0.5,19 L0.5,5.90247392 C0.5,5.77620386 0.531880401,5.65197767 0.592685621,5.54131217 L3.28635261,0.638838253 C3.41811973,0.399022096 3.67003518,0.25 3.94366699,0.25 L18.056333,0.25 Z M20,6.25 L2,6.25 L2,18.25 L20,18.25 L20,6.25 Z M8,15.25 L8,17.5 L3.5,17.5 L3.5,15.25 L8,15.25 Z M10.25,1.75 L4.385,1.75 L2.738,4.75 L10.25,4.75 L10.25,1.75 Z M17.6135,1.75 L11.75,1.75 L11.75,4.75 L19.261,4.75 L17.6135,1.75 Z"
                        id="🎨-Color"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);

export default Daas;
